import { SHIPPING_CONFIDENCE_EXPERIMENT } from './constants';
import { shouldShowSellerFriction } from './helpers/shouldShowSellerFriction';

import { useExperiments } from '@/modules/experiments/useExperiments';
import { useProductBySlugExtendedPDP } from '@/modules/product/hooks/useProductBySlugExtendedPDP';

/**
 * Whether this PDP should swap its purchase CTAs for the seller-friction
 * experience. False while the extended payload loads, preventing a flash
 * of the standard CTAs. Reads the decision without requesting one, so
 * mounting this never logs exposure; that is owned by
 * ShippingConfidenceExperimentGate.
 */
export function useSellerFriction() {
  const [decisions] = useExperiments([SHIPPING_CONFIDENCE_EXPERIMENT], {
    deferred: true,
  });
  const { data: productExtended, isLoading } = useProductBySlugExtendedPDP();

  return (
    !isLoading &&
    shouldShowSellerFriction(
      productExtended?.shipping_confidence?.level,
      decisions[SHIPPING_CONFIDENCE_EXPERIMENT]
    )
  );
}
